import { Button, IconButton, Paper } from "@material-ui/core";
import { vendorListStyle } from "./style";
import { VendorContactList } from "./vendorContact/VendorContactList";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { IconSettings, IconVendors } from "icons";
import { VendorStats } from "./vendorStats/VendorStats";
import VendorConfig from "./VendorConfig/VendorConfig";
import { VendorDetachedTemplate } from "./vendorDetachedTemplate/VendorDetachedTemplate";
import { useState } from "react";

export const VendorOverview = ({ vendor, setSelectedVendor }) => {
    const classes = vendorListStyle()
    const [openConfig, setOpenConfig] = useState(false);

    return (
        <>
            <Paper className={classes.overviewContainer}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setSelectedVendor(null)}
                    startIcon={<ArrowBackIcon />}>
                    Back
                </Button>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginRight: '2rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '2rem 0' }}>
                        <IconVendors style={{ fontSize: 40, marginRight: 16 }} />
                        <h3 className={classes.vendorName} style={{ margin: 0 }}>
                            {vendor?.name}
                        </h3>
                    </div>
                    <div>
                        <IconButton onClick={() => setOpenConfig(true)}>
                            <IconSettings />
                        </IconButton>
                    </div>
                </div>
                <VendorStats vendorId={vendor.id} />
                <VendorContactList vendor={vendor} />
                <VendorDetachedTemplate vendorId={vendor.id} />
                <VendorConfig
                    open={openConfig}
                    setOpen={setOpenConfig}
                    vendor={vendor}
                />
            </Paper>
        </>)
}